import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { filterReducer } from './filter.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('filter', filterReducer) 
  ]
})
export class FilterModule { }
